import Main from './Main';
import "./styles/app.scss";

function App() {
  return (
      <div className="App">
        <Main />
      </div>
    );
}

export default App;